import { Stack, TextField } from 'gantri-components';
import { useAtom } from 'jotai';
import { addDesignModalAtoms } from '../../../add-design-modal.atoms';

export const AddDesignModalNameStepContent = () => {
  const [name, setName] = useAtom(addDesignModalAtoms.name);

  return (
    <Stack>
      <TextField
        placeholder="Name of your design"
        value={name}
        onTextChange={setName}
      />
    </Stack>
  );
};
